var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iv-text-center iv-m-t-40"},[_c('img',{attrs:{"src":require("@/assets/images/no-data.png")}}),_c('p',{staticClass:"iv-fs-16 iv-fc-45 iv-m-t-20"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }